import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { segmentsQueryKeys } from "./queryKeys";

import type { SegmentVacancyPreviewResponse } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

type UseSegmentVacancyPreviewParams = {
  segmentId?: string;
};

export function useSegmentVacancyPreview({
  segmentId,
}: UseSegmentVacancyPreviewParams) {
  return useQuery<SegmentVacancyPreviewResponse, AxiosError>({
    queryKey: segmentsQueryKeys.vacancyPreview(segmentId),
    queryFn: () =>
      instance
        .get<SegmentVacancyPreviewResponse>(
          `/api/v2/Segments/${segmentId}/vacancies/preview`,
        )
        .then((res) => res.data),
    enabled: Boolean(segmentId),
    staleTime: 20 * 60 * 1000,
    refetchOnMount: true, // Overrides the global false so a `segment:*` realtime invalidation (api/realtime.ts) refetches on return
  });
}
